import React from 'react';

interface YouTubeEmbedProps {
  youtubeId: string;
  title?: string;
}

export const YouTubeEmbed: React.FC<YouTubeEmbedProps> = ({ youtubeId, title = 'Featured Video' }) => {
  return (
    <div className="w-full aspect-video rounded-lg overflow-hidden bg-muted border">
      <iframe
        src={`https://www.youtube.com/embed/${youtubeId}?modestbranding=1&showinfo=0&rel=0`}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className="w-full h-full"
        loading="lazy"
      />
    </div>
  );
};
